module.exports = __webpack_public_path__ + "img/image_news_Tiny_Tan_collabo03.cc3037c1.png";